const BASE = process.env.VUE_APP_BASE_API_URL || 'http://localhost:3000'
export const BASE_API_URL = `${BASE}/api/admin`
